import styled, { SimpleInterpolation, css } from 'styled-components';
import { Media } from 'enums';

type ILayoutProps = {
  customStyle?: SimpleInterpolation;
  $isHome?: boolean;
};

const LAYOUT_COLUMN_GAP = 40;
const LEFT_BLOCK_WIDTH = 434;

export const LayoutStyled = styled.section<ILayoutProps>`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: row;
  padding: 30px 20px 32px;

  background-color: ${({ theme }) => theme.colors.background};

  ${({ customStyle }) => customStyle};

  background-image: none;

  @media ${Media.tablet} {
    padding: 30px 40px 100px;
  }

  @media ${Media.notebook} {
    padding: 0 80px 0 0;
    column-gap: ${LAYOUT_COLUMN_GAP}px;
  }
`;

export const LeftBlockStyled = styled.div`
  flex: 0 0 ${LEFT_BLOCK_WIDTH}px;
  padding: 60px 0px 0 80px;
  z-index: 1;
`;

export const LeftDecorTree = styled.img<{ $isSpring?: boolean }>`
  display: none;
  pointer-events: none;
  will-change: transform;

  @media ${Media.notebook} {
    display: block;
    position: fixed;
    top: 672px;
    z-index: -1;

    ${({ $isSpring }) =>
      $isSpring
        ? css`
            left: 474px;
            transform: translate3d(-99%, 0, 0);
          `
        : css`
            left: 0;
            transform: none;
          `}
  }

  @media ${Media.desktop} {
    top: 622px;
  }
`;

export const RightBlockStyled = styled.div<{
  adjustWidthForLeftBlock: boolean;
}>`
  flex: 1 1 auto;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0px;
  z-index: 0;
  @media ${Media.tablet} {
    margin: 60px 0px 150px 0;
  }
  @media ${Media.notebook} {
    ${({ adjustWidthForLeftBlock }) =>
      adjustWidthForLeftBlock &&
      css`
        max-width: calc(100% - ${LEFT_BLOCK_WIDTH}px - ${LAYOUT_COLUMN_GAP}px);
      `}
  }
`;
